import { Component, Input, OnInit } from '@angular/core';
import { PopupService } from 'src/app/services/popup.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @Input() popupText: string;
  @Input() popupColor: string;

  constructor(private popupService: PopupService) { }

  ngOnInit(): void {
  }

  closePopup() {
    this.popupService.closePopup();
  }

}
